import { useTranslation } from 'react-i18next';
import { featuredArticles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function ArticleGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-12">
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-900 font-semibold leading-tight shrink-0">
            {t('usefulArticles')}
          </h2>
          <p className="text-sm text-foreground-500 font-body max-w-md leading-relaxed">
            {t('articlesDescription')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, index) =>
            index === 0 ? (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group relative overflow-hidden rounded-lg bg-foreground-900 text-background-50 p-6 flex flex-col justify-end min-h-[360px] cursor-pointer"
              >
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-50 transition-opacity duration-300"
                />
                <div className="relative z-10">
                  <span className="inline-block px-3 py-1 bg-accent-500/90 text-background-50 rounded-full text-xs font-label font-medium mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-xl md:text-2xl text-background-50 font-semibold mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-background-50/70 font-body line-clamp-2">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-sm text-accent-300 font-label font-medium">
                    {t('readMore')}
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </span>
                </div>
              </Link>
            ) : (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer text-left hover:bg-background-200/70 transition-colors duration-300 block"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 text-foreground-700 rounded-full text-xs font-label font-medium">
                    {article.category}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg text-foreground-900 font-semibold mb-2 group-hover:text-accent-500 transition-colors duration-300">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 font-body line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm text-accent-500 font-label font-medium">
                    {t('readMore')}
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </span>
                </div>
              </Link>
            ),
          )}
        </div>
      </div>
    </section>
  );
}